function stripHtml(value) {
  return (value || "").replace(/<[^>]*>/g, "");
}

export function normalizeForSearch(value) {
  return stripHtml(value)
    .toLowerCase()
    .replace(/-/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function scoreNameMatch(query, name) {
  if (!query || !name) {
    return 0;
  }

  if (name === query) {
    return 1000;
  }

  if (name.startsWith(query)) {
    return 800;
  }

  if (name.includes(query)) {
    return 600;
  }

  const tokens = query.split(" ").filter((token) => token.length > 0);
  if (tokens.length <= 1) {
    return 0;
  }

  const allTokensFound = tokens.every((token) => name.includes(token));
  if (!allTokensFound) {
    return 0;
  }

  const escapedTokens = tokens.map((token) =>
    token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  );
  const closeTogetherPattern = new RegExp(escapedTokens.join(".{0,3}"));
  if (closeTogetherPattern.test(name)) {
    return 700;
  }

  return 500;
}

export function getProductRelevanceScore(query, product) {
  const normalizedQuery = normalizeForSearch(query);
  if (!normalizedQuery) {
    return 0;
  }

  const queryVariants = [
    normalizedQuery,
    normalizedQuery.replace(/\s+/g, "-"),
    normalizedQuery.replace(/\s+/g, ""),
  ];

  const names = [
    product.globalProductName,
    product.name,
    product.variant_name,
  ]
    .filter(Boolean)
    .map(normalizeForSearch);

  let bestScore = 0;
  for (const name of names) {
    for (const queryVariant of queryVariants) {
      bestScore = Math.max(bestScore, scoreNameMatch(queryVariant, name));
    }
  }

  return bestScore;
}

export function sortProductsByRelevance(products, query) {
  if (!Array.isArray(products) || products.length <= 1 || !query) {
    return products;
  }

  return products
    .map((product, index) => ({
      product,
      index,
      score: getProductRelevanceScore(query, product),
    }))
    .sort((a, b) => {
      if (b.score !== a.score) {
        return b.score - a.score;
      }

      const sortNoA = a.product.sortNo || 0;
      const sortNoB = b.product.sortNo || 0;
      if (sortNoA !== sortNoB) {
        return sortNoA - sortNoB;
      }

      return a.index - b.index;
    })
    .map(({ product }) => product);
}
